<template>
  <div class="hefeiLawyer">
    <div class="text_center"><sec-title Text="合肥推荐律师"></sec-title></div>
    <div class="ht_list between wrap">
      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_1.png" />
        </div>
        <div class="ht_text">法律聚焦</div>
      </div>
      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_2.png" />
        </div>
        <div class="ht_text">罪名库</div>
      </div>
      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_3.png" />
        </div>
        <div class="ht_text">热门条例</div>
      </div>

      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_4.png" />
        </div>
        <div class="ht_text">合同范本</div>
      </div>

      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_5.png" />
        </div>
        <div class="ht_text">自媒体</div>
      </div>

      <div class="ht_item between">
        <div class="ht_img2">
          <img src="../../../assets/question/ht_6.png" />
        </div>
        <div class="ht_text">法律文书</div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import viewMore from "views/home/components/viewMore";
export default {
  components: {
    secTitle,
    viewMore,
  },
};
</script>

<style lang="scss" scope>
.hefeiLawyer {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .ht_list {
    margin-bottom: 40px;
    .ht_item {
      margin-top: 32px;
      border-radius: 10px;
      width: 360px;
      height: 160px;
      padding: 0 65px;
      background-color: #fff;
      &:hover {
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      }
      .ht_img2 {
        width: 105px;
        height: 107px;
      }
      .ht_text {
        font-size: 24px;
        color: #333;
      }
    }
  }
}
</style>